export enum ClientScreen {
	MOBILE = 'MOBILE',
	DESKTOP = 'DESKTOP',
}
